export function TargetExperience({period, role, org, points = []}){
  return(
    <article className="target-experience">
      <p className="experience-period">{period}</p>
      <h4 className="subtitle">{role}</h4>
      <p className="experience-org">{org}</p>
      {points.length > 0 && (
        <ul className="experience-points">
          {points.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
      )}
    </article>
  );
}
